export enum EFeatureTypes {
  RM = 'RM',
  RMLite = 'RMLite',
  RockMakerWeb = 'RockMaker Web',
  RockMaker = 'Rock Maker',
  RockMakerTitle = 'ROCK MAKER',
  RockMakerLite = 'RockMaker Lite',
  RockMakerLiteTitle = 'Rock Maker Lite',
  RockMakerLiteTitleUppercase = 'ROCK MAKER Lite',
  SelectedFeature = 'selectedFeature',
}

export enum EFeatureDescriptions {
  RockMaker = 'Full feature access',
  RockMakerLite = 'Image viewing, Read-only access',
}

export enum EUserTypes {
  All = 1,
  RM = 2,
  RMLite = 3,
}
